/* eslint-disable indent */
import DialogActions from '@mui/material/DialogActions';
import styled from 'styled-components';

import { COLORS } from '../../../../../theme';

export const StyledDialogFormActions = styled(DialogActions)`
  && {
    padding: ${({ theme }) => theme.spacing.m1} 0;
    width: calc(100% + ${({ theme }) => theme.spacing.m4});
    margin: 0 -${({ theme }) => theme.spacing.s4};
  }

  .MuiButton-root + .MuiButton-root {
    margin-left: ${({ theme }) => theme.spacing.s3};
  }

  ${({ $border }) => $border && `border-top: 1px solid ${COLORS.black10};`}

  ${({ $fixed, theme }) =>
    $fixed &&
    `
      && {
        position: absolute;
        bottom: 0;
        right: 0;
        left: 0;
        z-index: 10;
        width: auto;
        margin: 0;
        padding: ${theme.spacing.m1};
        background-color: ${COLORS.white};
      }
  `}
`;
